import styled from 'styled-components';

export const PaginationContainer = styled.div`
  font-family: InspireTWDC;
  display: flex;
  justify-content: space-between;
`;

export const PageDetails = styled.div`
  font-size: 12px;
  line-height: 18px;
`;
